"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UPDATE_DEVICE_NAME_QUERY = "\n    mutation UpdateDeviceName($deviceId: ID!, $deviceName: String!) {\n      updateDeviceName(deviceId: $deviceId, deviceName: $deviceName) {\n        deviceId\n        model\n        family\n        name\n      }\n    }\n";
exports.default = UPDATE_DEVICE_NAME_QUERY;
//# sourceMappingURL=updateDeviceName.js.map